//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CooperativeDisperseList",
  data() {
    return {
      filterForm: {
        date: "",
        workStartTimeStr: "",
        workEndTimeStr: "",
        employeeName: "",
        categoryId3: "",
        machineryModel: "",
        machineryCode: "",
        imei: "",
        workTypeCode: "",
      },
      machineCategories: [],
      cropWork2Data: [],
      works: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      masterId: "",
    };
  },
  watch: {
    "filterForm.date"(n) {
      console.log(n);
      if (n && n.length == 2) {
        this.filterForm.workStartTimeStr = n[0];
        this.filterForm.workEndTimeStr = n[1];
      } else {
        this.filterForm.workStartTimeStr = "";
        this.filterForm.workEndTimeStr = "";
      }
    },
  },
  mounted() {
    this.getDisperseWorkList();
    this.getMachineCategorys();
    this.getCropWork2();
  },
  created() {
    this.masterId = this.$route.query.$businessAccountId;
  },
  methods: {
    /**
     * @descripttion: 获取散活作业列表
     * @Author: juanjuanhui
     * @Date: 2022-04-21 10:57:08
     */
    getDisperseWorkList() {
      this.getAllFilters();
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.masterId };
      Object.assign(params, params, this.allFilters);
      this.$http.cooperative.getDisperseWorkList(params).then((res) => {
        let { recordTotal, content: works } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.works = works;
      });
    },
    /**
     * @descripttion: 获取机具分类
     * @Author: juanjuanhui
     * @Date: 2021-11-25 21:24:54
     */
    getMachineCategorys() {
      this.$http.common.getMachineCategorys().then((res) => {
        this.machineCategories = res.data;
      });
    },
    /**
     * @descripttion: 获取作业类型二级
     * @Author: juanjuanhui
     * @Date: 2022-04-21 15:54:32
     */
    getCropWork2() {
      this.$http.common.getCropWork2().then((res) => {
        this.cropWork2Data = res.data;
      });
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:06:58
     */
    getAllFilters() {
      let { date, ...data } = this.filterForm;
      this.allFilters = { ...data };
      if (this.allFilters.categoryId3 == -1) {
        delete this.allFilters.categoryId3;
      }
      if (this.allFilters.workTypeCode == -1) {
        delete this.allFilters.workTypeCode;
      }
    },
    /**
     * @descripttion:
     * @Author: juanjuanhui
     * @Date: 2022-04-22 09:12:04
     * @param {*} params 当前数据项
     */
    handleLookDetail(params) {
      let { id, employeeId, machineIdentity, imei, workTime, iotType } = params;
      this.$router.push({
        path: "/cooperative/disperse/detail",
        query: { id, employeeId, machineIdentity, imei, workTime, iotType },
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getDisperseWorkList();
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2022-04-21 16:53:32
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getDisperseWorkList();
    },
    /**
     * @Description: 重置条件
     * @Author: zhanghongquan
     * @Date: 2022-03-30 15:35:56
     * @param {*}
     */
    handleResetFilter(filterForm) {
      this.$refs[filterForm].resetFields();
      this.pagination.currentPage = 1;
      this.filterForm.date = "";
      this.filterForm.workStartTimeStr = "";
      this.filterForm.workEndTimeStr = "";
      this.getDisperseWorkList();
    },
  },
};
